export const FEATURE_ENPOINT = '/feature';
